import type { IIconType } from '@duel/icon';
import DuelIcon from '@duel/icon';
import * as React from 'react';

export interface IIconProps {
	style: IIconType;
	isHidden?: boolean;
	className?: string;
	color?: string;
	size?: string;
}

export default class DSXIcon extends React.Component<IIconProps> {
	public render() {
		const { className, isHidden, style, color, size } = this.props;

		const type = style || 'info';

		const icon = !isHidden && (
			<DuelIcon type={type} color={color} size={size} className={className}>
				{this.props.children}
			</DuelIcon>
		);
		return icon;
	}
}
